<div class="d-flex flex-column h-100 overflow-hidden">
  <app-nav-menu class="d-none d-sm-block nav-container" *ngIf="topBarService.navbarShow$ | async"></app-nav-menu>
  <div [ngClass]="(topBarService.navbarShow$ | async) ? 'base-container-top-bar' : 'base-container'">
    <router-outlet></router-outlet>
  </div>
</div>
